export const ErrorPageLayout = {
    slots: ['SlbErrorContainerSlot'],
};
